"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUICK_BUY_OUTLINED_ICON = exports.QUICK_BUY_OUTLINED_CN_ICON = exports.QUICK_BUY_LOADING_ICON = exports.QUICK_BUY_FILLED_ICON = exports.QUICK_BUY_FILLED_CN_ICON = exports.QUICK_BUY_BUTTON_STATE_WAITING = exports.QUICK_BUY_BUTTON_STATE_SUCCESS = exports.QUICK_BUY_BUTTON_STATE_LOADING = exports.QUICK_BUY_BUTTON_STATE_ERROR = exports.QUICK_BUY_BUTTON_STATE_DEFAULT = exports.QUICK_BUY = exports.ICON_BUTTON_SKELETON = exports.ICON_BUTTON_SIZE = exports.ICON_BUTTON_PHONE_SIZE = void 0;
const QUICK_BUY = exports.QUICK_BUY = 'quick-buy';
const QUICK_BUY_LOADING_ICON = exports.QUICK_BUY_LOADING_ICON = 'QuickBuySuccessIcon';
const QUICK_BUY_OUTLINED_ICON = exports.QUICK_BUY_OUTLINED_ICON = 'QuickBuyOutlinedIcon';
const QUICK_BUY_OUTLINED_CN_ICON = exports.QUICK_BUY_OUTLINED_CN_ICON = 'QuickBuyOutlinedCnIcon';
const QUICK_BUY_FILLED_ICON = exports.QUICK_BUY_FILLED_ICON = 'QuickBuyFilledIcon';
const QUICK_BUY_FILLED_CN_ICON = exports.QUICK_BUY_FILLED_CN_ICON = 'QuickBuyFilledCnIcon';
const QUICK_BUY_BUTTON_STATE_DEFAULT = exports.QUICK_BUY_BUTTON_STATE_DEFAULT = 'default';
const QUICK_BUY_BUTTON_STATE_ERROR = exports.QUICK_BUY_BUTTON_STATE_ERROR = 'error';
const QUICK_BUY_BUTTON_STATE_LOADING = exports.QUICK_BUY_BUTTON_STATE_LOADING = 'loading';
const QUICK_BUY_BUTTON_STATE_SUCCESS = exports.QUICK_BUY_BUTTON_STATE_SUCCESS = 'success';
const QUICK_BUY_BUTTON_STATE_WAITING = exports.QUICK_BUY_BUTTON_STATE_WAITING = 'waiting';
const ICON_BUTTON_SIZE = exports.ICON_BUTTON_SIZE = 45;
const ICON_BUTTON_PHONE_SIZE = exports.ICON_BUTTON_PHONE_SIZE = 35;
const ICON_BUTTON_SKELETON = exports.ICON_BUTTON_SKELETON = 'IconButtonSkeleton';
